import React, { useEffect, useState } from 'react'
import { v2_categories, v2_channels } from '../../../actions/v2/masterData';
import { useDebouncedValue } from '../../../customHook/useDebouncedValue';

const ACCEPTED_REPORT_RECEIVED_STATUS = 'Accepted, Report received';
const ACCEPTED_REPORT_RECIEVED_STATUS = 'Accepted, Report recieved';
const LEGACY_ACCEPTED_STATUS = 'Accepted';

const getStatusCount = (statusCount, status) => Number(statusCount?.[status] || 0);

const getAcceptedStatusCount = (statusCount) => Number(
    statusCount?.[ACCEPTED_REPORT_RECEIVED_STATUS]
    ?? statusCount?.[ACCEPTED_REPORT_RECIEVED_STATUS]
    ?? statusCount?.[LEGACY_ACCEPTED_STATUS]
    ?? 0
);

const getTotalStatusCount = (statusCount) => (
    getStatusCount(statusCount, 'Unscheduled')
    + getStatusCount(statusCount, 'Scheduled')
    + getStatusCount(statusCount, 'Accepted with Comments')
    + getAcceptedStatusCount(statusCount)
    + getStatusCount(statusCount, 'Not Applicable')
);

const toApiStatus = (status) => {
    if (status === ACCEPTED_REPORT_RECEIVED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS) {
        return LEGACY_ACCEPTED_STATUS;
    }
    return status;
};

const toFilterStatus = (status) => {
    if (status === LEGACY_ACCEPTED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS) {
        return ACCEPTED_REPORT_RECEIVED_STATUS;
    }
    return status || '';
};

const Filter = ({ statusCount, total, onChangeFilter, initialFilter = {} }) => {
    const totalCount = total ?? getTotalStatusCount(statusCount);

    // Kept out of `state` so typing doesn't fire the filter effect on every keystroke.
    const [keyword, setKeyword] = useState(initialFilter.keyword || '');
    const debouncedKeyword = useDebouncedValue(keyword);

    const [state, setState] = useState({
        channel: { name: 'channel', value: initialFilter.channelId || '', options: [] },
        category: { name: 'category', value: initialFilter.categoryId || '', options: [] },
        status: { name: 'status', value: toFilterStatus(initialFilter.status), options: ['Unscheduled', 'Scheduled', 'Accepted with Comments', ACCEPTED_REPORT_RECEIVED_STATUS, 'Not Applicable'] },
        fromDate: { name: 'fromDate', value: initialFilter.fromDate || '' },
        toDate: { name: 'toDate', value: initialFilter.toDate || '' },
        favourite: { name: 'favourite', value: Boolean(initialFilter.favourite) },
        hasMyComment: { name: 'hasMyComment', value: Boolean(initialFilter.hasMyComment) },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };

    const handleClearSearch = () => {
        setKeyword('');
    };

    useEffect(() => {

        const model = {
            channelId: state.channel.value,
            categoryId: state.category.value,
            favourite: state.favourite.value,
            hasMyComment: state.hasMyComment.value,
            keyword: debouncedKeyword,
            status: toApiStatus(state.status.value),
            fromDate: state.fromDate.value,
            toDate: state.toDate.value,
        }
        onChangeFilter(model)
    }, [state, debouncedKeyword])
    useEffect(() => {
        v2_channels().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    channel: {
                        ...prev.channel,
                        options: res.result.map((item) => ({
                            label: item.CHANNEL_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        });

        v2_categories().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    category: {
                        ...prev.category,
                        options: res.result.map((item) => ({
                            label: item.CATEGORY_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        })


    }, []);
    return (
        <div className="plan-approval-index-top filters-card-top">
            <div className="filters-card">
                <h5 className="filters-title" style={{ fontSize: 13 }}>
                    FAT Filters
                </h5>
                <div className="filter-tab-channels-box filter-top-box">
                    <div className="input-box">
                        <div className="search-section-box search-fat-box">
                            <form
                                className="app-search "
                                onSubmit={(e) => e.preventDefault()}
                            >
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control search-input-with-clear"
                                        placeholder="Search subject/FAT no/remark..."
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                    <span className="bx bx-search-alt" />
                                    {keyword && (
                                        <button
                                            type="button"
                                            className="search-clear-btn"
                                            aria-label="Clear search"
                                            title="Clear search"
                                            onClick={handleClearSearch}
                                        >
                                            <i className="bx bx-x" />
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="input-box">
                        <select className="form-select w200"
                            name={state.channel.name}
                            value={state.channel.value}
                            onChange={handleChange}

                        >
                            <option value="">Channels </option>
                            {state.channel.options.map((option) => {
                                return (
                                    <option value={option.value}>{option.label}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-box">
                        <select className="form-select" style={{ width: 180 }}
                            name={state.category.name}
                            value={state.category.value}
                            onChange={handleChange}
                        >
                            <option value="">Categories</option>
                            {state.category.options.map((option) => {
                                return (
                                    <option value={option.value}>{option.label}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-box">
                        <select className="form-select" style={{ width: 180 }}
                            name={state.status.name}
                            value={state.status.value}
                            onChange={handleChange}
                        >
                            <option value="">Status</option>
                            {state.status.options.map((option) => {
                                return (
                                    <option value={option}>{option}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-box">
                        <input
                            className="form-control"
                            type="text"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => !e.target.value && (e.target.type = "text")}
                            placeholder="Scheduled From Date"
                            onChange={handleChange}
                            value={state.fromDate.value}
                            name={state.fromDate.name}
                        />
                    </div>
                    <div className="input-box">
                        <input
                            className="form-control"
                            type="text"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => !e.target.value && (e.target.type = "text")}
                            placeholder="Scheduled To Date"
                            onChange={handleChange}
                            value={state.toDate.value}
                            name={state.toDate.name}
                        />
                    </div>
                    <div className={state.hasMyComment.value ? 'input-box active' : 'input-box'}>
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'hasMyComment',
                                        value: !state.hasMyComment.value,
                                    },
                                })
                            }
                        >
                            <i className="fa fa-edit" /> Has My Comments
                        </button>
                    </div>
                    <div className={state.favourite.value ? 'input-box active' : 'input-box'}>
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'favourite',
                                        value: !state.favourite.value,
                                    },
                                })
                            }
                        >
                            <i className="bx bx-star" /> My Favourites
                        </button>
                    </div>
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply" /> Reply Owed
                        </button>
                    </div> */}
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply-all" /> Reply Owed - Urgent
                        </button>
                    </div> */}
                    {/* <div className="input-box">
                        <button type="button">
                            <i className="fa fa-reply-all" /> Reply Owed Third Party
                        </button>
                    </div> */}
                    <div className="input-box">
                        <button type="button">
                            <i className="fa fa-edit" /> Has Draft Reply
                        </button>
                    </div>



                </div>
            </div>
            <div className="counter-box-right fat-counter-box-right">
                <h5 className="box-title">FAT Status</h5>
                <div className="count-box">
                    <h6>
                        Total <span>{totalCount || 0}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        Unscheduled <span>{getStatusCount(statusCount, 'Unscheduled')}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        Scheduled <span>{getStatusCount(statusCount, 'Scheduled')}</span>
                    </h6>
                </div>

                <div className="count-box">
                    <h6>
                        AQ <span>{getStatusCount(statusCount, 'Accepted with Comments')}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        AA <span>{getAcceptedStatusCount(statusCount)}</span>
                    </h6>
                </div>
                <div className="count-box">
                    <h6>
                        NA <span>{getStatusCount(statusCount, 'Not Applicable')}</span>
                    </h6>
                </div>
            </div>
        </div>
    )
}

export default Filter
